import { defineFilterSpec, enumField, multiField, rangeField, text } from '@/lib/api/filter-spec';

import type { OrderSummaryFilterFormValues, OrderSummaryListFilters } from './types';

/** Single declaration of the Order Summary filters, shared by the api call, the drawer, the page
 *  and the export. Field order mirrors the panel (Figma 32:194749).
 *
 *  Multi-selects join to comma strings; the deployed DTO's `toStringArray` transform splits them
 *  again. The four date bounds are plain `YYYY-MM-DD` strings and travel as `enumField`s
 *  (pass-through, falsy-stripped) — `rangeField` is for NUMERIC `${base}From`/`${base}To` pairs
 *  only. No `param` renames anywhere: each key already is the backend's own param name. */
const spec = defineFilterSpec<OrderSummaryListFilters, OrderSummaryFilterFormValues>([
  text('search'),
  multiField('customerIds'),
  multiField('cities'),
  enumField('orderDateFrom'),
  enumField('orderDateTo'),
  enumField('deliveryDateFrom'),
  enumField('deliveryDateTo'),
  multiField('orderStatus'),
  rangeField('amount'),
  rangeField('itemCount'),
]);

export const orderSummaryToListQuery = spec.toListQuery;
export const orderSummaryToDefaults = spec.toDefaults;
export const orderSummaryToFilters = spec.toFilters;
export const orderSummaryHasActiveFilters = spec.hasActiveFilters;
